import { faCheck } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MenuItem } from "@mui/material";
import * as React from 'react';

interface IProps {
    text?: React.ReactNode;
    value: any;
    currentSelection: any,
    onClick: (opt: any) => void;
}

type Props = IProps & React.PropsWithChildren;

export const MprcMenuItemChecked = (props: Props) => {

    const { text, value, currentSelection, onClick, children } = props;

    return (
        <MenuItem onClick={() => { onClick(value); }}>
            {currentSelection === value && <React.Fragment><FontAwesomeIcon fixedWidth icon={faCheck} />&nbsp;</React.Fragment>}
            {currentSelection !== value && <div className="fa fa-check fa-w-16 fa-fw"></div>}
            {text || children}
        </MenuItem>
    );
};
